<div class="select-container mt-8" appClickOutside (clickOutside)="clickOutside()" [isActive]="isListShown">
    <div class="select-input-wrapper input-wrapper displayFlex align-item-center" (click)="handleTriggerClick($event)">
      <input class="select-input input has-suffix"
      [ngStyle]="showError()? {'border':'1px solid #B00020','border-radius':'6px'}:{}"
        [readonly]="!canSearch && !canAdd"
        [disabled]="formControl && formControl.disabled"
        [placeholder]="placeholder"
        [(ngModel)]="displayValue"
        (blur)="handleInputBlur()"
        (change)="handleInputChange()"
        (keyup)="handleInputChange($event)"
        (keypress)="preventEnterKeyBehaviour($event)"
        (keydown)="handleKeyDown($event)"
        [ngClass]="{'input-error': showError(), 'has-clear': showClear}"
        (keypress)="checkInput($event)"
      (paste)="validateInput($event)"
      />
      <img
        *ngIf="showClear && displayValue && (!formControl || !formControl.disabled)"
        (click)="clearInput($event)"
        src="assets/clear-circle-filled.svg"
        class="input-icon clear-icon"/>
      <img [src]="isListShown ? 'assets/caret-up-large-blue.svg' : 'assets/caret-down-large.svg'" class="input-icon suffix"/>
    </div>
    <div class="select-list" *ngIf="isListShown">
      <ng-container *ngFor="let optionList of optionLists; let listIndex = index;">
        <div  *ngIf="listIndex!=0" class="line"></div>
        <div class="list-header" *ngIf="optionLists.length > 1">{{optionList.name}}</div>
        <ul class="option-list">
          <li class="select-option fs-12"
            *ngFor="let option of optionList.filteredOptions; let optionIndex = index;"
            (click)="onOptionClick(option)"
            [ngClass]="{'active-item': optionIndex == activeOption && listIndex == activeList}"
          >
            <img *ngIf="hasIcon" [src]="option.icon" class="mr-10"/>
            <span>{{getOptionLabel(option)}}</span>
          </li>
          <li class="no-results" *ngIf="optionList.filteredOptions && !optionList.filteredOptions.length">No options available</li>
        </ul>
      </ng-container>
    </div>
    <div class="error" *ngIf="showError() && formControl.errors.required"><img src="assets/error-16.svg" alt="" class="error-icon">{{errorMessages.required}}</div>
    <div class="error" *ngIf="showError() && (formControl.errors.pattern || formControl.errors.secure)"><img src="assets/error-16.svg" alt="" class="error-icon">{{config.errorMessage || errorMessages.pattern}}</div>
  </div>
